const toStringOrNull = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

export const createMessengerV2SyncCoordinator = () => {
  const entries = new Map();

  const run = ({ conversationId = null, requestKey = null, task = null } = {}) => {
    const key = toStringOrNull(conversationId);
    const normalizedRequestKey = toStringOrNull(requestKey) || 'base';
    if (!key || typeof task !== 'function') {
      return Promise.resolve(null);
    }

    const existingEntry = entries.get(key);
    if (existingEntry?.accepting === true) {
      if (
        existingEntry.currentRequestKey === normalizedRequestKey ||
        existingEntry.nextRequestKey === normalizedRequestKey
      ) {
        return existingEntry.promise;
      }
      existingEntry.nextTask = task;
      existingEntry.nextRequestKey = normalizedRequestKey;
      return existingEntry.promise;
    }

    const entry = {
      accepting: true,
      currentRequestKey: null,
      nextRequestKey: normalizedRequestKey,
      nextTask: task,
      promise: null,
    };
    const drain = async () => {
      let result = null;
      let finalError = null;

      while (entry.nextTask) {
        const currentTask = entry.nextTask;
        entry.currentRequestKey = entry.nextRequestKey;
        entry.nextTask = null;
        entry.nextRequestKey = null;
        try {
          result = await currentTask();
          finalError = null;
        } catch (error) {
          finalError = error;
        }
      }

      entry.accepting = false;
      if (finalError) throw finalError;
      return result;
    };

    entry.promise = drain().finally(() => {
      if (entries.get(key) === entry) {
        entries.delete(key);
      }
    });
    entries.set(key, entry);
    return entry.promise;
  };

  return {
    run,
    clear: () => entries.clear(),
  };
};

export default createMessengerV2SyncCoordinator;
